import React from 'react';
import { Button } from '@/components/ui/button';
import { Archive, Trash2, UserPlus } from 'lucide-react';

const AdminUsersTab = ({
  users,
  selectedUsers,
  toggleSelectAllUsers,
  toggleUserSelection,
  bulkArchiveUsers,
  bulkDeleteUsers,
  setInviteDialog
}) => {
  return (
    <>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="font-heading text-2xl font-bold text-slate-900">Manage Users</h2>
          {selectedUsers.length > 0 && (
            <p className="text-sm text-slate-500 mt-1">{selectedUsers.length} user(s) selected</p>
          )}
        </div>
        <div className="flex items-center gap-3">
          {selectedUsers.length > 0 && (
            <>
              <Button
                onClick={bulkArchiveUsers}
                variant="outline"
                className="rounded-sm border-amber-300 text-amber-600 hover:bg-amber-50"
                data-testid="bulk-archive-btn"
              >
                <Archive className="w-4 h-4 mr-2" />
                Archive ({selectedUsers.length})
              </Button>
              <Button
                onClick={bulkDeleteUsers}
                variant="outline"
                className="rounded-sm border-red-300 text-red-600 hover:bg-red-50"
                data-testid="bulk-delete-btn"
              >
                <Trash2 className="w-4 h-4 mr-2" />
                Delete ({selectedUsers.length})
              </Button>
            </>
          )}
          <Button
            onClick={() => setInviteDialog(true)}
            className="bg-greek-blue hover:bg-greek-blue-dark text-white rounded-sm"
            data-testid="invite-user-btn"
          >
            <UserPlus className="w-4 h-4 mr-2" />
            Invite User
          </Button>
        </div>
      </div>

      <div className="bg-white rounded-sm border border-slate-200 overflow-hidden">
        <table className="w-full">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr>
              <th className="px-4 py-4 text-left">
                <input
                  type="checkbox"
                  checked={selectedUsers.length === users.filter(u => u.role !== 'admin').length && users.filter(u => u.role !== 'admin').length > 0}
                  onChange={toggleSelectAllUsers}
                  className="w-4 h-4 rounded border-slate-300 text-greek-blue focus:ring-greek-blue"
                  data-testid="select-all-users"
                />
              </th>
              <th className="px-4 py-4 text-left text-sm font-semibold text-slate-700">Name</th>
              <th className="px-4 py-4 text-left text-sm font-semibold text-slate-700">Email</th>
              <th className="px-4 py-4 text-left text-sm font-semibold text-slate-700">Role</th>
              <th className="px-4 py-4 text-left text-sm font-semibold text-slate-700">Status</th>
              <th className="px-4 py-4 text-left text-sm font-semibold text-slate-700">Joined</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200">
            {users.map((u) => (
              <tr key={u.id} className={`hover:bg-slate-50 ${selectedUsers.includes(u.id) ? 'bg-blue-50' : ''}`} data-testid={`user-row-${u.id}`}>
                <td className="px-4 py-4">
                  {u.role !== 'admin' && (
                    <input
                      type="checkbox"
                      checked={selectedUsers.includes(u.id)}
                      onChange={() => toggleUserSelection(u.id)}
                      className="w-4 h-4 rounded border-slate-300 text-greek-blue focus:ring-greek-blue"
                      data-testid={`select-user-${u.id}`}
                    />
                  )}
                </td>
                <td className="px-4 py-4 text-sm text-slate-900">{u.first_name} {u.last_name}</td>
                <td className="px-4 py-4 text-sm text-slate-600">{u.email}</td>
                <td className="px-4 py-4">
                  <span className={`px-2 py-1 text-xs rounded-sm font-medium capitalize ${
                    u.role === 'admin' ? 'bg-purple-100 text-purple-700' :
                    u.role === 'chair' ? 'bg-blue-100 text-blue-700' :
                    u.role === 'committee' ? 'bg-cyan-100 text-cyan-700' :
                    u.role === 'sponsor' ? 'bg-amber-100 text-amber-700' :
                    'bg-slate-100 text-slate-700'
                  }`}>
                    {u.role}
                  </span>
                </td>
                <td className="px-4 py-4">
                  <span className={`px-2 py-1 text-xs rounded-sm font-medium ${
                    u.is_archived ? 'bg-slate-200 text-slate-600' : 'bg-green-100 text-green-700'
                  }`}>
                    {u.is_archived ? 'Archived' : 'Active'}
                  </span>
                </td>
                <td className="px-4 py-4 text-sm text-slate-500">
                  {new Date(u.created_at).toLocaleDateString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default AdminUsersTab;